import { render, staticRenderFns } from "./SponsorUserLoans.vue?vue&type=template&id=168a2f17"
import script from "./SponsorUserLoans.vue?vue&type=script&lang=js"
export * from "./SponsorUserLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports